import PropTypes from 'prop-types';

export const cicCommentTemplatesPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    cicFeeReasonCommentTemplateId: PropTypes.string,
    text: PropTypes.string,
  }),
);
